import { render, staticRenderFns } from "./ThemeDoc.vue?vue&type=template&id=24cb4d1c&scoped=true"
import script from "./ThemeDoc.vue?vue&type=script&lang=js"
export * from "./ThemeDoc.vue?vue&type=script&lang=js"
import style0 from "./ThemeDoc.vue?vue&type=style&index=0&id=24cb4d1c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24cb4d1c",
  null
  
)

export default component.exports